import { GetterTree, MutationTree, ActionTree } from "vuex/types/index";
import { ContractStatus } from "@foxone/api/src/models/defi";
import { ProductTypes } from "defi/constants";

const state = () => {
  const contracts = ProductTypes.reduce((m, k) => ({ ...m, [k]: [] }), {});
  return {
    ...contracts,
    loading: false
  };
};

export type ContractsState = ReturnType<typeof state>;

const getters: GetterTree<ContractsState, {}> = {
  getContracts(state) {
    return ProductTypes.reduce((c, t) => {
      return [...c, ...state[t]];
    }, [] as any);
  },
  getGroupedContracts(state) {
    return ProductTypes.reduce((group, t) => ({ ...group, [t]: state[t] }), {});
  }
};

const mutations: MutationTree<ContractsState> = {
  SET_CONTRACTS(state, { data, type }) {
    state[type] = data;
  },
  SET_LOADING(state, data) {
    state.loading = data;
  }
};

const actions: ActionTree<ContractsState, {}> = {
  async loadContracts({ commit }) {
    // const loadContract = async type => {
    //   const actions = this.$api.defi.getActionsBySchemeType(type);
    //   const status = [
    //     ContractStatus.RUNNING,
    //     ContractStatus.SETTLEMENT,
    //     ContractStatus.REDEMPTION
    //   ];
    //   const contracts = await actions.getContracts({
    //     status: status.join(",")
    //   });
    //   commit("SET_CONTRACTS", { data: contracts, type });
    // };
    // commit("SET_LOADING", true);
    // await Promise.all(ProductTypes.map(type => loadContract(type)));
    // commit("SET_LOADING", false);
  },
  removeContracts({ commit }) {
    ProductTypes.forEach(type => commit("SET_CONTRACTS", { data: [], type }));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
